import React from 'react';
import { Box, Grid, IconButton, TextField, Typography } from '@material-ui/core';
import AddBoxIcon from '@material-ui/icons/AddBox';
import DeleteIcon from '@material-ui/icons/Delete';
import { SettingsFieldsProps } from './types';

const DEFAULT_ALGORITHM = 'RS256';

const JwtCertificateFields: React.FC<SettingsFieldsProps> = ({
  s,
  handleChange,
  setFieldValue,
}) => {
  const claims = (s.claims ?? {}) as Record<string, string>;

  const handleAddClaim = () => {
    setFieldValue('settings.claims', { ...claims, '': '' });
  };

  const handleRemoveClaim = (key: string) => {
    const next = { ...claims };
    delete next[key];
    setFieldValue('settings.claims', next);
  };

  const handleClaimKeyChange = (idx: number, newKey: string) => {
    const next: Record<string, string> = {};
    Object.entries(claims).forEach(([k, v], i) => {
      next[i === idx ? newKey : k] = v;
    });
    setFieldValue('settings.claims', next);
  };

  const handleClaimValueChange = (key: string, value: string) => {
    setFieldValue('settings.claims', { ...claims, [key]: value });
  };

  return (
    <>
      <Grid item xs={12}>
        <TextField
          fullWidth
          name="settings.payloadAlgorithm"
          value={s.payloadAlgorithm ?? DEFAULT_ALGORITHM}
          onChange={handleChange}
          label="Payload Algorithm"
          variant="outlined"
        />
      </Grid>
      <Grid item xs={12}>
        <Box display="flex" alignItems="center" mb={1}>
          <Typography variant="subtitle2">Claims</Typography>
          <IconButton size="small" style={{ marginLeft: 8 }} onClick={handleAddClaim}>
            <AddBoxIcon fontSize="small" color="primary" />
          </IconButton>
        </Box>
      </Grid>
      {Object.entries(claims).map(([claimKey, claimValue], idx) => (
        <React.Fragment key={idx}>
          <Grid item xs={5}>
            <TextField
              fullWidth
              size="small"
              label="Key"
              value={claimKey}
              onChange={(e) => handleClaimKeyChange(idx, e.target.value)}
              variant="outlined"
            />
          </Grid>
          <Grid item xs={5}>
            <TextField
              fullWidth
              size="small"
              label="Value"
              value={claimValue}
              onChange={(e) => handleClaimValueChange(claimKey, e.target.value)}
              variant="outlined"
            />
          </Grid>
          <Grid item xs={2} style={{ display: 'flex', alignItems: 'center' }}>
            <IconButton size="small" onClick={() => handleRemoveClaim(claimKey)}>
              <DeleteIcon fontSize="small" />
            </IconButton>
          </Grid>
        </React.Fragment>
      ))}
    </>
  );
};

export default JwtCertificateFields;
